module.exports = __webpack_public_path__ + "static/media/email-symbol.8459a29f.svg";